const fa = {
  s1_title: "نیروبان",
  s1_description:
    " نیروبان یک استارتاپ سبز در حوزه مدیریت انرژی است که هدف اش کنترل مصرف برق در پیک مصرف توسط ارائه اطلاعات آنلاین مصرف مشترک از طریق اپلیکیشن تلفن همراه می باشد ",
  enterPhoneNumber: "شماره تلفن همراه خود را وارد کنید",
  callMe: "خبرم کن!",
  sended: "ارسال شد!",
  s2_title: "نمایش اطلاعات به صورت آنلاین",
  s2_description:
    "با نمایش اطلاعات آنلاین، علاوه بر کاهش مصرف و کاهش هزینه به نصف، مصرف کلی برق در ساعات اوج مصرف را نیز کاهش می دهد",
  s3_title: "هشدار افزایش هزینه",
  s3_description:
    "زمانی که مصرف برق مشترک از حالت عادی خارج می شود، با توجه به نظارت مستمر هوش تجاری بر مصرف وی و سابقه مصرف ، به او هشدار می دهد و راه های کاهش مصرف و همچنین بهترین الگوی مصرف انرژی هر مشترک را پیشنهاد می کند. او می فرستد",
  s4_title: "نمودار برق",
  s4_description:
    "در این قسمت می توانید تاریخ مصرف ماه های قبل را به صورت نموداری مشاهده کرده و با هم مقایسه کنید",
  s5_title: "خانه هوشمند",
  s5_description:
    "با استفاده از این قسمت از اپلیکیشن، چراغ های اتاق های خالی دیگر را خاموش کرده و از پیک مصرف جلوگیری می کند و دما، میزان آلودگی و رطوبت خانه را نیز اندازه گیری کنید",
  s6_title: "همین الان خانه هوشمند رو تجربه کن",
  s6_description:
    "برای استفاده از این دمو با لپتاب ویا موبایل اول وارد شوید وبایک موبایل دیگر کد QR زیر را اسکن کنید و با اپلیکیشن ظاهر شده، دمو ما را کنترل کنید",
  contactUs: "تماس با ما",
  name: "نام و نام خانوادگی",
  phoneNumber: "موبایل",
  city: "شهر",
  subject: "موضوع پیام",
  email: "ایمیل",
  text: "متن پیام",
  sendPm: "ارسال پیام",
  sentPm: "پیام شما ارسال شد!",
  copyright: "تمامی حقوق این سایت محفوظ و متعلق به نیروبان است .",
  whatsapp: "            واتساپ:۰۹۳۶۸۸۱۹۹۶۲",
  app_monitor: " سامانه کنترل و پایش ",
  app_power: " مصرف برق",
  app_userId: "شناسه قبض",
  app_password: "کلمه عبور",
  app_login: "ورود",
  app_currentUsage: "میزان مصرف لحظه‌ای",
  app_voltUnit: "ولت",
  app_amperUnit: "آمپر",
  app_periodUsage: "مصرف دوره‌ای",
  app_kwh: "کیلووات ساعت",
  app_cost: "هزینه",
  app_priceUnit: "تومان",
  app_status: "وضعیت شما",
  app_customerStatus: "مشترک کم مصرف",
  app_moreDetail: "نمایش جزيیات",
  app_dearCustomer: "مشترک گرامی",
  app_notification: `
  مصرف شما از حد مجاز بیشتر شده لطفا با ورود به بخش خانه هوشمند
  وسایل برقی اضافی را خاموش کنید
`,
  app_analyze: "برسی مصرف",
  lamp: "لامپ",
  on: "روشن",
  off: "خاموش",
  split: "فن",
  humidity:"رطوبت هوا",
  co2:'میزانCO2',
  temp:"دمای داخل"
};

export default fa;
// s1_title: "",
// s1_description:'',
